import { useState } from "react";
import PropTypes from "prop-types";
import { StyledSelectableUpperUnits, StyledUpperUnitsInfo } from "../../../styles/StyledSelectableUpperUnits/StyledSelectableUpperUnits";
import { QueryLoader } from "../../Loader";
import { SelectableRadioDecision } from ".";

export default function SelectableSingleDecision({ data, isLoading, isError, error, setSelectedDecisionID }) {
	const [selectedDecision, setSelectedDecision] = useState();

	const onChangeValue = (event) => {
		setSelectedDecision(event.target.value);
		setSelectedDecisionID(event.target.value);
	};

	return isError ? (
		<p>{error}</p>
	) : isLoading ? (
		<StyledUpperUnitsInfo>
			<QueryLoader />
		</StyledUpperUnitsInfo>
	) : data.length > 0 ? (
		<StyledSelectableUpperUnits onChange={onChangeValue}>
			{data.map((el) => (
				<SelectableRadioDecision key={el.id} selectedDecision={selectedDecision} data={el} value={el.id.toString()} />
			))}
		</StyledSelectableUpperUnits>
	) : (
		<StyledUpperUnitsInfo>
			<p>No units found</p>
		</StyledUpperUnitsInfo>
	);
}

SelectableSingleDecision.propTypes = {
	data: PropTypes.array,
	isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	isError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	error: PropTypes.string,
	setSelectedDecisionID: PropTypes.func,
};
